import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "title-1" }, "Oups... Impossible de trouver la page demandée", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Retour à l'accueil")

import { useMetaTitle } from "../app/pageMeta";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

useMetaTitle().setTitle("404");

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_router_link, {
      to: { name: 'index' },
      class: "btn btn-primary"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ], 64))
}
}

})